// DEV-998: neutralize a value that a spreadsheet would evaluate as a formula when the exported
// CSV is opened (CSV injection, found by the 4.2 penetration test in Sponsor Protocol ID).
// Prefixing an apostrophe makes Excel and LibreOffice treat the cell as literal text.
// The set is wider than the four characters named on the ticket: tab and carriage return are
// also formula lead-ins, so omitting them would leave the finding half open.
// Only the first character matters, so 'A=B' is harmless and is left alone.
const CSV_FORMULA_LEAD_CHARS = ['=', '+', '-', '@', '\t', '\r'];

// Generic so a caller's type survives the round trip: only strings are ever rewritten, and a
// number or Date column passes through with the type it came in with.
export const sanitizeCsvValue = <T>(value: T): T => {
    if (typeof value !== 'string' || value.length === 0) {
        return value;
    }

    return (CSV_FORMULA_LEAD_CHARS.includes(value[0]) ? `'${value}` : value) as T;
};
